export default __webpack_public_path__ + "static/media/category_8.902bc771.png";